import QuestionFormInterface from "./questionFormInterface";
import questionFormRepository from "../../../../infrastructure/repository/impl/question-form/question_form_repository";
import { QuestionForm } from "../../../entities/search-form/question_form";

class QuestionFormUseCases implements QuestionFormInterface {
  async responseQuestions(
    searchFormID: number,
    trainingID: number,
    questionID: number,
    questionForm: QuestionForm
  ): Promise<number> {
    return await questionFormRepository.responseQuestions(
      searchFormID,
      trainingID,
      questionID,
      questionForm
    );
  }

  async get(
    searchFormID: number,
    trainingID: number,
    page: number
  ): Promise<QuestionForm> {
    return await questionFormRepository.get(searchFormID, trainingID, page);
  }
}

export default new QuestionFormUseCases() as QuestionFormInterface;
